<template>
  <div class="solution_customized">
    <!-- 顶部大图横幅 -->
    <div
        class="top_img"
        :style="{
        'background-image': `url(${solutionData.topImage || require('../../static/img/new_top_bg.png')})`
      }"
    >
      <p class="title">{{ topTitle }}</p>
      <p class="subtitle">{{ topIntro }}</p>
    </div>


    <!-- 面包屑导航 -->
    <div class="nav_container">
      <div class="breadcrumb_section">
        <div class="breadcrumb_content">
          <span @click="$router.push('/')">{{ $t("Home") }}</span>
          <span class="separator">></span>
          <span class="current">{{$t("Customized")}}</span>
        </div>
      </div>
      <div class="page_nav_div">
        <p @click="goToSolution('FTTx')">{{$t("FTTx")}}</p>
        <p @click="goToSolution('DataCenter')">{{$t("Data Center")}}</p>
        <p class="active">{{$t("Customized")}}</p>
      </div>
    </div>

    <!-- 主内容区 -->
    <div class="main_content">
      <p class="section_title">{{$t("Customized Solution")}}</p>
      <div class="content_wrapper">
        <!-- 三个服务卡片 -->
        <div class="service_cards">
          <div class="service_card" v-for="(service, index) in serviceList" :key="index"
               :style="{'background-image': `url(${service.image})`}">
            <div class="card_overlay"></div>
            <div class="card_content">
              <p class="h3">{{ service.title }}</p>
              <p class="description">{{ service.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as API from "@/api/index";

export default {
  data() {
    return {
      solutionData: {},
      serviceList: []
    };
  },
  computed: {
    topTitle() {
      if (this.$i18n.locale === 'zh') {
        return this.solutionData.topTitleCn || "";
      } else if (this.$i18n.locale === 'es') {
        return this.solutionData.topTitleEs || this.solutionData.topTitleEn || "";
      }
      return this.solutionData.topTitleEn || "";
    },
    topIntro() {
      if (this.$i18n.locale === 'zh') {
        return this.solutionData.topIntroCn || "";
      } else if (this.$i18n.locale === 'es') {
        return this.solutionData.topIntroEs || this.solutionData.topIntroEn || "";
      }
      return this.solutionData.topIntroEn || "";
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getSolutionCategoryData(3);
    this.getSolutionSubCategories();
  },
  methods: {
    goToSolution(type) {
      this.$router.push(`/Solution${type}`);
    },
    // 获取解决方案分类数据
    getSolutionCategoryData(id) {
      API.getSolutionCategoryInfo(id)
        .then((res) => {
          if (res.code === 0 && res.solutionCategory) {
            this.solutionData = res.solutionCategory;
          }
        })
        .catch(() => {});
    },
    // 获取解决方案二级分类列表
    async getSolutionSubCategories() {
      try {
        const res = await API.getSolutionSubCategoryList({ parentId: 3 });
        if (res.code === 0 && res.page && res.page.list) {
          this.serviceList = res.page.list.map(subcategory => ({
            title: this.getLocalizedTitle(subcategory),
            description: this.getLocalizedDescription(subcategory),
            image: subcategory.image
          }));
        }
      } catch (error) {
        console.error('Failed to fetch solution subcategories:', error);
      }
    },
    // 根据当前语言获取标题
    getLocalizedTitle(item) {
      return this.$getI18nField(item, 'title');
    },
    // 根据当前语言获取描述
    getLocalizedDescription(item) {
      if (this.$i18n.locale === 'zh') {
        return item.contentCn || item.contentEn || '';
      } else if (this.$i18n.locale === 'es') {
        return item.contentEs || item.contentEn || '';
      }
      return item.contentEn || '';
    }
  }
};
</script>

<style lang="scss" scoped>
.solution_customized {

  .top_img {
    padding:0 12.5%;
    height: 47rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    .title {
      text-align: left;
      font-size: 7rem;
      font-family: bold;
      color: white;
      margin: 7rem 0 0 0;
      align-self: flex-start;
    }

    .subtitle {
      width: 40%;
      text-align: left;
      font-size: 2.4rem;
      color: #E7E8EA;
      margin-top: 1rem;
    }
  }

  .breadcrumb_section {
    background: white;
    padding: 3rem 0 0;
    width: 50%;

    .breadcrumb_content {
      max-width: 140rem;
      margin: 0 auto;
      padding: 0 2rem;
      font-size: 1.8rem;
      color: #BDC0C5;
      text-align: left;
      font-family: regular;

      span {
        cursor: pointer;
        transition: color 0.3s;

        &:hover {
          color: #1d2087;
        }

        &.separator {
          margin: 0 1rem;
          color: #BDC0C5;
          cursor: default;
        }

        &.current {
          color: #1D2087;
          cursor: default;
        }
      }
    }
  }

  .nav_container {
    display: flex;
    background: white;
    border-bottom: 1px solid #BDC0C5;
    padding: 0 12.5% 0;
  }

  .main_content {
    padding: 15rem 0 30rem;

    .section_title {
      margin: 0 0 8rem 0;
      padding-left: 12.5%;
      font-size: 5rem;
      color: #212121;
      text-align: left;
    }

    .content_wrapper {
      margin: 0 12.5%;
      padding: 0;
    }

    .service_cards {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 1.6rem;
      height: 75rem;

      .service_card {
        position: relative;
        border-radius: 0.8rem;
        overflow: hidden;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        transition: transform 0.3s ease, box-shadow 0.3s ease;

        &:hover {
          //transform: translateY(-5px);
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);

          .card_overlay {
            background: linear-gradient(to top, #1D2087 0%, rgba(29, 32, 135, 0.6) 20%,rgba(29, 32, 135, 0) 50%,rgba(29, 32, 135, 0) 100%);
          }

          .card_content {
            .description {
              max-height: 20rem;
              opacity: 1;
              margin-top: 1rem;
            }
          }
        }

        .card_overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.3) 50%, transparent 100%);
          transition: background 0.3s ease;
        }

        .card_content {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          padding: 2.5rem;
          z-index: 1;

          .h3 {
            font-size: 2.8rem;
            color: white;
            padding: 0;
            margin: 0;
            text-align: left;
            font-family: bold;
          }

          .description {
            font-size: 2.2rem;
            color: white;
            text-align: left;
            max-height: 0;
            opacity: 0;
            overflow: hidden;
            font-family: regular;
            margin: 0;
            transition: all 0.4s ease;
            display: flex;
            align-items: flex-start;

            &::before {
              content: '';
              display: inline-block;
              width: 0.8rem;
              height: 0.8rem;
              background-color: #9CCF86;
              border-radius: 50%;
              margin-right: 1.5rem;
              margin-top: 0.7rem;
              flex-shrink: 0;
            }
          }
        }
      }
        }
      }
    }


  .contacts_section {
    background: linear-gradient(135deg, #1a4d8f 0%, #2563a8 100%);
    padding: 6rem 2rem;

    .h2 {
      text-align: center;
      font-size: 3.6rem;
      color: white;
      margin: 0 0 3rem;
    }

    .contact_card {
      max-width: 80rem;
      margin: 0 auto;
      background: white;
      border-radius: 1rem;
      padding: 4rem;

      .card_title {
        font-size: 2rem;
        color: $color2C;
        margin: 0 0 3rem;
        text-align: center;
      }

      .contact_info {
        display: flex;
        justify-content: center;
        gap: 8rem;

        .info_item {
          display: flex;
          align-items: center;
          gap: 1.5rem;

          i {
            font-size: 3rem;
            color: $textBlueColor;
          }

          .label {
            font-size: 1.2rem;
            color: $color5E;
            margin: 0 0 0.5rem;
          }

          .value {
            font-size: 1.6rem;
            color: $color2C;
            margin: 0;
          }
        }
      }
    }
  }

@media (max-width: 1200px) {
  .solution_customized {
    .top_img {
      height: 30rem;

      .title {
        font-size: 3.5rem;
      }

      .subtitle {
        width: 80%;
        font-size: 1.4rem;
      }
    }

    .nav_container {
      flex-direction: column;
      padding: 0;
    }

    .breadcrumb_section {
      display: none;
      width: 100%;
    }

    .page_nav_div {
      width: 100% !important;
      padding: 0 !important;
      justify-content: center !important;
      display: flex;

      p {
        padding: 0.8rem 1.2rem;
        font-size: 1.2rem;
      }
    }

    .main_content {
      .service_cards {
      }
    }

    .contacts_section {
      .contact_card .contact_info {
        flex-direction: column;
        gap: 2rem;
      }
    }
  }
}
@media (max-width: 768px) {
  .solution_customized {
    .top_img {
      padding: 0 2rem;
      height: 30rem;
      display: flex;

      .title {
        font-size: 3rem;
        margin: 5rem 0 0 0;
      }

      .subtitle {
        width: 80%;
        font-size: 1.4rem;
        margin-top: 1rem;
        line-height: 1.5;
      }
    }

    .nav_container {
      padding: 0;
      display: flex;
    }

    .breadcrumb_section {
      padding: 2rem 0 0;
    }

    .main_content {
      padding: 8rem 0 15rem;

      .section_title {
        font-size: 3rem;
        margin: 0 0 4rem 0;
        padding-left: 2rem;
      }

      .content_wrapper {
        margin: 0 2rem;
        flex-direction: row;
      }
    }

    .service_cards {
      display: flex;
      overflow-x: auto;
      gap: 1.5rem;
      height: 50rem!important;

      .service_card {
        min-width: 28rem;
        flex-shrink: 0;
        .card_content{
          .h3{
            font-size: 2.2rem!important;
          }
          .description{
            font-size: 1.4rem!important;
          }
        }
      }
    }
  }
}
</style>
